@if ($sorMode()) {
  <div class="item-status-cell sor">
    <w-badge
      [label]="$statusLabel()"
      [tooltip]="$statusLabel()"
      [color]="$statusStyle().color"
      [backgroundColor]="$statusStyle().backgroundColor"
      [borderColor]="$statusStyle().borderColor"
      [onlyShowTooltipIfOverflow]="true"
      size="xs"
      mode="squared" />

    @if ($locked()) {
      <i class="fa-regular fa-lock line-lock" pTooltip="You can't change this line" tooltipStyleClass="wb-dark-tooltip" tooltipPosition="top" [showDelay]="200" appendTo="body" aria-label="You can't change this line"></i>
    }
  </div>
} @else {
  <div class="item-status-cell">
    <div class="status-name" [class.locked]="$locked()">
      <w-badge
        [label]="$statusLabel()"
        [tooltip]="$statusLabel()"
        [color]="$statusStyle().color"
        [backgroundColor]="$statusStyle().backgroundColor"
        [onlyShowTooltipIfOverflow]="true"
        mode="squared"
        borderColor="transparent" />

      @if ($locked()) {
        <i class="fa-regular fa-lock line-lock" pTooltip="You can't change this line" tooltipStyleClass="wb-dark-tooltip" tooltipPosition="top" [showDelay]="200" appendTo="body" aria-label="You can't change this line"></i>
      }
    </div>

    @if (!$hideBadges()) {
      <div class="status-badges">
        @for (badge of $badges(); track badge.label) {
          @if (badge.url) {
            <a class="finance-status" [class.active]="badge.active" [title]="badge.tooltip" [href]="badge.url" target="_blank" rel="noopener noreferrer" (click)="$event.stopPropagation()">{{ badge.label }}</a>
          } @else {
            <span class="finance-status" [class.active]="badge.active" [title]="badge.tooltip">{{ badge.label }}</span>
          }
        }

        <span
          class="finance-status supplied-contractor"
          [class.active]="$suppliedBySubcontractor()"
          [title]="$suppliedBySubcontractor() ? 'Supplied by subcontractor' : 'Not supplied by subcontractor'">
          <i class="fa-regular fa-truck"></i>
        </span>
      </div>
    }
  </div>
}
